import { useCallback, useEffect, useState } from "react";

export default function useIsMobile(breakPoint=800) {
  const mediaQuery = `(max-width: ${breakPoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(mediaQuery).matches);

  const checkDevice = useCallback(() => {
    setIsMobile(window.matchMedia(mediaQuery).matches);
  }, [mediaQuery]);

  useEffect(() => {
    const query = window.matchMedia(mediaQuery);
    const onChange = (event) => setIsMobile(event.matches);

    setIsMobile(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, [mediaQuery]);

  return {
    checkDevice,
    isMobile,
  };
}
